<div class="input-group form-group-no-border filter-item d-flex justify-content-end">
    <label class="label text-end" [title]="filter.label" [innerText]="filter.label" for="{{componentId}}" [class.required-field]="filter.required"></label>
    <div class="form-check mb-0 checkbox">
        <label class="form-check-label mb-2">
            <input class="form-check-input" [disabled]="filter.disabled" type="checkbox" (change)="valueChange()" [(ngModel)]="value" id="{{componentId}}">
            <span class="form-check-sign"></span>
        </label>
    </div>
</div>